const getFunctionUrl = (functionName: string) => {
  const prefix =
    process.env.NODE_ENV === "development" ? "http://localhost:8888" : "";
  return `${prefix}/.netlify/functions/${functionName}`;
};

export default getFunctionUrl;
